import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_TRIP_REQUEST,
  CLEAR_TRIP_REQUESTS,
  FLAG_GETTING_TRIP_REQUESTS,
  FLAG_TRIP_REQUEST_ACTIVITY,
  GET_TRIP_REQUEST,
  GET_TRIP_REQUESTS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_TRIP_REQUESTS:
      return state.setIn(['all', 'loading'], payload);
    case GET_TRIP_REQUESTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_TRIP_REQUESTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_TRIP_REQUEST_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_TRIP_REQUEST:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_TRIP_REQUEST:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
